module.exports = __webpack_public_path__ + "static/media/1021419.8ed155ab.jpg";